(() => {






function $124cedb5ba74d82e$var$addToggleButtons() {
    const toggleBtns = document.querySelectorAll(".toggle-button");
    console.log(toggleBtns);
    Array.from(toggleBtns, (btn)=>btn.addEventListener("click", toggleEl));
    function toggleEl(e) {
        const button = e.target;
        const elClass = button.dataset.el;
        const el = [
            ...document.querySelectorAll(`.${elClass}`)
        ];
        const state = button.dataset.istoggled;
        el.forEach((el)=>{
            console.log(el);
            if (state === "true") delete el.dataset.toggled;
            else el.dataset.toggled = "true";
        });
        Array.from(document.querySelectorAll(`[data-el="${elClass}"]`), (button)=>{
            button.dataset.istoggled = state === "false" ? "true" : "false";
        });
    }
}
document.addEventListener('DOMContentLoaded', $124cedb5ba74d82e$var$addToggleButtons);

















//add support for open comments immediatly looking at url
//when show comments button is clicked we need to
// 1. show modal
// 2. add close listener
// 3. fetch disqus comments window.loadDisqus
const $c6f733427bd664e3$var$commentButton = document.querySelector(".comments-btn a");
$c6f733427bd664e3$var$commentButton && $c6f733427bd664e3$var$commentButton.addEventListener("click", $c6f733427bd664e3$var$getDisqusCommentsOnce);
function $c6f733427bd664e3$var$getDisqusCommentsOnce(e) {
    loadDisqus();
    $c6f733427bd664e3$var$commentButton.removeEventListener("click", $c6f733427bd664e3$var$getDisqusCommentsOnce); //remove this function so it wont fire again
}





})();
//# sourceMappingURL=main.js.map
